module.exports = __webpack_public_path__ + "static/media/b-sci-major-10_LR.a232037f.jpg";